import { Grid, useMediaQuery } from "@mui/material";
import { observer } from "mobx-react";
import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import theme from "../../../Theme/AppTheme";
import { useStore } from "../../../utils/useStore";
import { Routes } from "../../Navigation/Routes";
import ConfirmationDialog from "../../UI/AcxConfirmationDialog";
import {
    AnalystDashboardStore,
    FindNextEvalTask,
} from "./Stores/AnalystDashboardStore";
import AnalystEvaluationTable from "./Views/AnalystEvaluationTable";
import AnalystHistoryCard from "./Views/AnalystHistoryCard";
import Header from "./Views/Header";

interface OwnProps {}

type Props = OwnProps;

const AnalystDashboard: FunctionComponent<Props> = observer((props) => {
    const store = useStore(AnalystDashboardStore);
    const navigate = useNavigate();

    const mediumDownMatch = useMediaQuery(theme.breakpoints.down("lg"));

    const goToEvalPage = (evalId: string) => {
        const organizationId = store.orgSelectorStore.orgId;

        if (!evalId || !organizationId) {
            throw new Error("EvalId or OrgId empty");
        }

        navigate(Routes.makeEvaluationRoute(organizationId, evalId));
    };

    return (
        <Grid container item xs={12}>
            <ConfirmationDialog
                onClose={store.closeNextEvalDialog}
                title={"Searching queues for your next evaluation"}
                isLoading={store.getTaskLoading(FindNextEvalTask)}
                noControls
                isOpen={store.showNextEvalDialog}
                errorMessage={store.getTaskError(FindNextEvalTask)?.message}
                content={store.noAdditionalEvalMsg}
            />

            <Grid
                container
                item
                xs={12}
                sx={{
                    backgroundColor: theme.palette.white.main,
                    boxShadow:
                        "0 0 3px 0 rgba(0,0,0,0.05), 0 1px 1px 0 rgba(0,0,0,0.05)",
                    height: "205px",
                }}
            >
                <Header goToEvalPage={goToEvalPage} />
            </Grid>

            <Grid
                container
                item
                xs={12}
                sx={{
                    paddingLeft: theme.spacing(3.5),
                    paddingRight: theme.spacing(3.5),
                    height: "calc(100% - 205px)",
                    width: "100%",
                }}
                direction="row-reverse"
            >
                <Grid
                    item
                    xs={2}
                    sx={{ marginTop: "2rem", marginBottom: "2rem" }}
                >
                    <AnalystHistoryCard
                        analystHistory={store.analystHistory}
                        rootCardStyle={{
                            height: "280px",
                        }}
                    />
                </Grid>

                <Grid
                    item
                    xs={9}
                    style={{
                        paddingRight: mediumDownMatch ? "" : "2rem",
                        height: "calc(100vh - 330px)",
                    }}
                >
                    <AnalystEvaluationTable goToEvalPage={goToEvalPage} />
                </Grid>
            </Grid>
        </Grid>
    );
});

export default AnalystDashboard;
